import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminLayout from "../../../components/admin/common/AdminLayout";
import AdminMain from "../../../components/admin/users/AdminMain";
import { fetchUsers, getUsers } from "../../../redux/slice/usersSlice";

const Users = () => {
  const users = useSelector(getUsers);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!users) {
      dispatch(fetchUsers("CLIENT"));
    }
  }, [dispatch, users]);

  return (
    <>
      <AdminLayout>
        <AdminMain />
      </AdminLayout>
    </>
  );
};

export default Users;
